import React, { useState } from 'react';
import ModalBody from '../modal/ModalBody';
import Modal from '../modal/Modal';
import ModalHeader from '../modal/ModalHeader';
import ErrorBoundary from '../ErrorBoundary';
import MapImageForm from './MapImageForm';
import Client from '../../utils/network';
import { InitialMapImage } from '../../reducers/map/mapReducer';
import { CreateImageIcon } from '../Icons/CreateImageIcon';

const defaultStats: InitialMapImage = {
    image: '',
    xPos: 0,
    yPos: 0,
    width: 1,
    height: 1,
    yScale: 1,
    xScale: 1,
    rotation: 0,
};

export const CreateMapImageModal = ({ loadMapImages } : { loadMapImages: () => void}) => {
    const [show, setShow] = useState(false);
    const [data, setData] = useState<InitialMapImage>(defaultStats);
    const toggle = () => {
        if(show) {
            setData(defaultStats);
        }
        setShow(!show);
    };

    const onSubmit = (data: InitialMapImage) => {
        try {
            Client.request('/api/map-image', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    mapImage: data,
                }),
            }).then(() => {
                loadMapImages();
                setShow(false);
                return;
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.log(err);
            });

        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
    };

    return (
        <>
            <button onClick={toggle}>
                <CreateImageIcon className='w-12 h-12' />
            </button>
            <Modal show={show} toggle={toggle} center>
                <ModalHeader toggle={toggle}>Create Map image</ModalHeader>
                <ErrorBoundary>
                    <ModalBody>
                        <div className="w-80">
                            <MapImageForm onSubmit={onSubmit} externalData={data} />
                        </div>
                    </ModalBody>
                </ErrorBoundary>
            </Modal>
        </>
    );
};


